export default "__VITE_ASSET__CaAOtZvl__"